/**
 * Centralized validation error keys for i18n translation.
 * Organized by module for better maintainability.
 *
 * Format: errors.{module}.{error_type}
 *
 * @example
 * t(VALIDATION_ERRORS.FIELD_REQUIRED)
 */
export const VALIDATION_ERRORS = {
    FIELD_REQUIRED: 'commons.validation_errors.field_required',
    FIELD_NOT_ALLOWED: 'commons.validation_errors.field_not_allowed',
    CHOOSE_AMONG: 'commons.validation_errors.choose_among',
    INVALID_EMAIL: 'commons.validation_errors.invalid_email',
    INVALID_PHONE: 'commons.validation_errors.invalid_phone',
    INVALID_WEBSITE: 'commons.validation_errors.invalid_website',
    INVALID_UUID: 'commons.validation_errors.invalid_uuid',
    INVALID_DATE: 'commons.validation_errors.invalid_date',
    INVALID_ENUM: 'commons.validation_errors.invalid_enum',
    INVALID_VAT_NUMBER: 'commons.validation_errors.invalid_vat_number',
    INVALID_FISCAL_CODE: 'commons.validation_errors.invalid_fiscal_code',
    INVALID_IBAN: 'commons.validation_errors.invalid_iban',
    INVALID_BIC: 'commons.validation_errors.invalid_bic',
    AT_LEAST_ONE_REQUIRED: 'commons.validation_errors.at_least_one_required',
    ENUM_REQUIRED: 'commons.validation_errors.enum',
    NUMBERS: {
        MUST_BE_NUMBER: 'commons.validation_errors.numbers.must_be_number',
        MUST_BE_POSITIVE: 'commons.validation_errors.numbers.must_be_positive',
        MUST_BE_INTEGER: 'commons.validation_errors.numbers.must_be_integer',
        AMOUNT_CANNOT_BE_ZERO: 'commons.validation_errors.numbers.amount_cannot_be_zero',
        MIN_VALUE: 'commons.validation_errors.numbers.min_value',
        MAX_VALUE: 'commons.validation_errors.numbers.max_value',
    },
    STRINGS: {
        MAX_LENGTH: 'commons.validation_errors.strings.max_length',
        MIN_LENGTH: 'commons.validation_errors.strings.min_length',
        EXACT_LENGTH: 'commons.validation_errors.strings.exact_length',
        REGEX_MISMATCH: 'commons.validation_errors.strings.regex_mismatch',
    },
    AUTH: {
        INVALID_PASSWORD_CONFIRMATION: 'auth.validation_errors.invalid_password_confirmation',
        PASSWORD_MIN_LENGTH: 'auth.validation_errors.password_min_length',
        PASSWORD_COMPLEXITY: 'auth.validation_errors.password_complexity',
    },
    DOCUMENT_PAYMENT_SCHEDULES: {
        ACCOUNT_REQUIRED: 'documentPaymentSchedule.validation_errors.account_required',
        DATE_REQUIRED: 'documentPaymentSchedule.validation_errors.date_required',
        SEPA_TRANSFER_LIMIT_EXCEEDED: 'documentPaymentSchedule.validation_errors.sepa_transfer_limit_exceeded',
    },
    FORECAST_PAYMENT_SCHEDULES: {
        AT_LEAST_ONE_SCHEDULE: 'forecastPaymentSchedule.validation_errors.at_least_one_schedule',
        DUPLICATE_INSTALLMENT_NUMBERS: 'forecastPaymentSchedule.validation_errors.duplicate_installment_numbers',
    },
    FORECAST_SERIES: {
        START_END_MONTH_CONFLICT: 'forecastSeries.validation_errors.payment_schedule_templates',
        AT_LEAST_ONE_TEMPLATE: 'forecastSeries.validation_errors.forecast_series',
        PERCENTAGES_MUST_SUM_100: 'forecastSeries.validation_errors.percentages_must_sum_100',
        TEMPLATES_COUNT_MISMATCH: 'forecastSeries.validation_errors.templates_count_mismatch',
        DAY_OF_MONTH_REQUIRES_LAST_DAY: 'forecastSeries.validation_errors.day_of_month_requires_last_day',
    },
    COMPANY: {
        NOT_YOUR_VAT_NUMBER: 'company.validation_errors.not_your_vat_number',
    },
};
//# sourceMappingURL=validation-errors-keys.js.map